import { PageFirstIcon } from './PageFirstIcon';

/**
 * author: Google
 * id DF23FF47-4DD3-4CB3-9BEC-6EE986B0FA65
 * name page-first
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/page-first.svg
 * tags
 */
export const FirstPageIcon = PageFirstIcon;
export default FirstPageIcon